if (!customElements.get('laserlab-press')) {
  customElements.define('laserlab-press', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      const button = this.querySelector('[data-press-pause]');
      if (button) {
        button.hidden = false;
        button.addEventListener('click', () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          button.setAttribute('aria-pressed', String(paused));
          const label = paused ? 'Start logorekken' : 'Sett logorekken på pause';
          button.setAttribute('aria-label', label);
          button.title = label;
        });
      }
      this.dataset.ready = 'true';
    }
  });
}
